/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'plus-round': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20.487 3.513c-4.684-4.684-12.29-4.684-16.974 0-4.684 4.684-4.684 12.29 0 16.974 4.684 4.684 12.29 4.684 16.974 0 4.684-4.684 4.684-12.318 0-16.974zM17.45 12.68c-.174.174-.434.29-.694.29h-3.76v3.759c0 .26-.114.52-.288.693-.174.174-.434.29-.694.29a.975.975 0 01-.982-.983v-3.76h-3.76a.975.975 0 01-.982-.982c0-.55.433-.983.982-.983h3.76V7.244c0-.549.433-.983.982-.983.55 0 .983.434.983.983v3.76h3.76c.548 0 .982.433.982.982-.03.26-.117.52-.29.693z" _fill="#27DBBD" fill-rule="evenodd"/>'
  }
})
